<template>
  <div class="container">
    <van-cell
      class="header"
      :title="`${name}`"
      title-class="title"
      :value="`活动账单：${amount}元`"
      value-class="value"
      :label="`编号：${id}`"
      label-class="label"
      center
    />
    <LongList
      :api-method="getData"
    >
      <template #default="{list}">
        <div
          v-for="(item,index) in list"
          :key="index"
          class="cell-card"
          @click="gotoActivityDetail(item)"
        >
          <div class="cell-head">
            <div class="head-left">
              {{ item.cutMonth|getMonth }}月 {{ item.poiName }}
            </div>
            <div
              v-if="getAbleCheckout(item)"
              class="head-right"
            >
              查看明细<van-icon name="arrow" />
            </div>
          </div>
          <div class="cell-row">
            <div>{{ getSubjectTypeName(item) }}</div>
            <div>
              账单金额：<span class="number">{{ item.agreementBillAmount }}元</span>
            </div>
          </div>
        </div>
      </template>
    </LongList>
  </div>
</template>
<script>
import LongList from '@/components/LongList';
import { formatYearMonth, getMonth } from '@/util/filter';
import Api from '@/api/bill';
import { ACTIVITY_BILL_TYPE } from '@/constants/bill';

export default {
  name: 'AgentActivityBillDetail',
  components: {
    LongList,
  },
  filters: {
    formatYearMonth,
    getMonth,
  },
  data() {
    const {
      billType, billMonth, id, name, amount,
    } = this.$route.query;
    return {
      billType,
      billMonth,
      id,
      name,
      amount,
    };
  },
  methods: {
    getData(pageNum, pageSize) {
      const { billType, billMonth, id: agreementId } = this;
      const params = {
        billType: Number(billType),
        billMonth,
        agreementId,
        pageNum,
        pageSize,
      };
      return Api.getAgentActivityBillDetail(params);
    },
    getSubjectTypeName(item) {
      // 未出订单不展示账单类型
      if (this.billType === ACTIVITY_BILL_TYPE.UNBILLED) {
        return '';
      } else {
        return item.subjectTypeName || '';
      }
    },
    getAbleCheckout(item) {
      // 合作商：10代表订单分润，商家：1代表订单分润
      // 订单分润可以查看明细
      return item.subjectType === 10;
    },
    gotoActivityDetail(item) {
      if (!this.getAbleCheckout(item)) {
        return;
      }
      const { billType, billMonth, id } = this;
      const {
        poiId, poiName, cutMonth, agreementBillAmount: amount,
      } = item;
      this.$router.push({
        name: 'AgentActivityMonthBillDetail',
        query: {
          billType,
          billMonth,
          id,
          poiId,
          poiName,
          cutMonth,
          amount,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 16px 16px 0;
}


.header {
  background: none;

  .title {
    text-align: left;
    font-weight: bold;
    font-size: 30px;
    color: black;
    width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: none;
  }
  .value {
    font-size: 28px;
    color:black;
  }
  .label {
    font-weight: normal;
    font-size: 24px;
    color:black;
  }
}

.cell-card {
  .cell-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 30px;

    .head-left {
      text-align: left;
    }

    .head-right {
      font-weight: normal;
      font-size: 26px;
      flex-basis: 180px;
      text-align: right;
    }
  }

  .cell-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    &:last-child {
      padding-bottom: 0;
    }

  }
}
</style>
